module.exports = __webpack_public_path__ + "img/how-step-2.644622ea.png";